import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TITLES = {
  '/login': 'Login',
  '/change-password-required': 'Change Password',
  '/dashboard': 'Dashboard',
  '/work-requests': 'Work Requests',
  '/work-orders': 'Work Orders',
  '/rooms': 'Assets & Rooms',
  '/assets': 'Assets & Rooms',
  '/branches': 'Branches',
  '/users': 'Users',
  '/inventory': 'Inventory',
  '/pm-plans': 'PM Scheduling',
  '/cost-analytics': 'Analytics',
  '/sla-policies': 'SLA Policies',
  '/sla-compliance': 'SLA Compliance',
  '/chat': 'Chat',
  '/notifications': 'Notifications',
  '/import-codes': 'Import Codes',
  '/system-status': 'System Status',
  '/data-checks': 'Data Checks',
  '/help': 'Help',
  '/search': 'Search',
  '/moltbot': 'MoltBot',
  '/super-admin': 'Super Admin',
  '/super-admin-audit': 'Super Admin Audit',
};

const BASE = 'UR Maintenance';

export function useDocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = Object.keys(TITLES)
      .sort((a, b) => b.length - a.length)
      .find((key) => pathname === key || pathname.startsWith(key + '/'));

    document.title = match ? `${BASE} — ${TITLES[match]}` : BASE;
  }, [pathname]);
}
